import { render, staticRenderFns } from "./ManageBarrel.vue?vue&type=template&id=6e9e0b09&"
import script from "./ManageBarrel.vue?vue&type=script&lang=ts&"
export * from "./ManageBarrel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports